import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { IntegrationMetadataContextState, IntegrationOperationType } from './types';

const defaultState: IntegrationMetadataContextState = {
  appDetails: undefined,
  apps: [],
  assignedIntegrations: {},
  mobileApps: [],
  operationType: IntegrationOperationType.CREATE,
  selectedIntegration: undefined,

  setAppDetails: noop,
  setApps: noop,
  setAssignedIntegrations: noop,
  setOperationType: noop,
  setSelectedIntegration: noop,
};

export const IntegrationMetadataContext =
  createContext<IntegrationMetadataContextState>(defaultState);
export const useIntegrationMetadataContext = () => useContext(IntegrationMetadataContext);
